import './functions/bxslider';
import AOS from 'aos';
//require('slick-carousel');
require('./polyfills/find-polyfill');

// Extend Jquery with simple toggleText function - used for More/Less buttons
$.fn.extend({
    toggleText: function(a, b){
        return this.text(this.text() == b ? a : b);
    }
});

// Extend jquery check if div is in viewport
$.fn.isOnScreen = function(){
    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};


$(window).on('load', function () {
    $('body').addClass('loaded');
});

let scrollRef = 0;
  $(window).on("resize scroll", function () {
    // increase value up to 10, then refresh AOS
    scrollRef <= 10 ? scrollRef++ : AOS.refresh();
  });


$(document).ready(function () {

     AOS.init({
        duration:1000,
        offset:5,
        delay:10,
      });

    //Mobile Menu
    $('.menu-toggle').click(function () {
        $(this).toggleClass('active');
        $('a.target-burger').toggleClass('toggled');
        $('.mobile-menu').slideToggle();
        $('body').addClass('menu-open');
    });


    // BACK TO TOP 
    // Back to top fade in and out if at top of screen
    $('.back-to-top').hide();
  
    $(window).scroll(function() {
      if ($(document).scrollTop() > 100) {
        $('.back-to-top').fadeIn(600);
      } else {
        $('.back-to-top').fadeOut(600);
      }
    });

    // Back to top function
    $('.back-to-top').on('click', function(){
        $('html,body').animate({
            scrollTop: 0
        }, 1000);
    });


    // IMAGE ROTATOR
     var hpSlider = $('.what-we-offer-rotator').bxSlider({
        speed: 500,
        pause: 8000,
        mode: 'fade',
        maxSlides: (window.innerWidth <= 767) ? 1 : 5,
        moveSlides: 1,
        shrinkItems: true,
        infiniteLoop: true,
        auto: true,
        pager: true,
        controls: false
    });


    // IMAGE ROTATOR - MOB ONLY
     var hpSlider = $('.mobile-image-rotator').bxSlider({
        speed: 500,
        pause: 8000,
        mode: 'fade',
        maxSlides: (window.innerWidth <= 767) ? 1 : 5,
        moveSlides: 1,
        shrinkItems: true,
        infiniteLoop: true,
        auto: true,
        pager: true,
        controls: false
    });


    // CONTACT FORM TEXTAREA AUTO GROW
    $("textarea").keyup(function(e) {
        while($(this).outerHeight() < this.scrollHeight + parseFloat($(this).css("borderTopWidth")) + parseFloat($(this).css("borderBottomWidth"))) {
            $(this).height($(this).height()+1);
        };
    });


    // TWO COL DROPDOWN LIST
    $('.dropdown-wrap h3').click(function () {
        if ($(this).parent().hasClass("show")) {
            $('.dropdown-wrap').removeClass('show');
            $($(this).parent().removeClass('show'));
            $('.dropdown-wrap.show .excerpt').hide();
        } else {
            $('.dropdown-wrap').removeClass('show');
            $($(this).parent().addClass('show'));
            $('.dropdown-wrap.show .excerpt').hide();
            $($(this).next().show());
        }
    });   


     // HIDE CF7 FORM ON SEND
    if ($('.wpcf7').length) {
        var wpcf7Elm = document.querySelector( '.wpcf7' );

        wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
          $('.form-wrap').hide();
        }, false );
    }

});


// WEBPACK FOOTER //
// ./assets/js/main.js